import Zoom from '../components/zoom.min.js';
import CustomSelect from '../components/customSelect';

import Store from '../components/store';
import Variants from '../components/variants';
import FormNotify from '../components/formNotify';
import Shipping from '../components/shipping';
import BuyWithGift from '../components/buyWithGift';

import Swiper, { Navigation, Thumbs, Pagination, EffectFade } from 'swiper';
Swiper.use([Navigation, Thumbs, Pagination, EffectFade]);

window.sliderProduct = [];

const Product = {
  // Aqui ficam os js do transacional
  $sectionProduct: $('[data-section-product]'),
  $wrapperImages: $('[data-section-product]').find('[data-product-images]'),
  $sliderProduct: $('[data-section-product]').find('[data-product-images] [data-main-slider]'),
  $thumbsProduct: $('[data-section-product]').find('[data-product-images] [data-slider-thumbs]'),
  /*
    Exibe as primeiras imagens do produto
    ** Importante para quando houver imagem por sku **
  */
  showFirstImages: function () {
    var _this = this;
    var variants = vnda.variants.all();
    var $imagesWithoutSkus = _this.$sliderProduct.find('.image-without-sku');
    var $thumbsWithoutSkus = _this.$thumbsProduct.find('.image-without-sku');

    if ($imagesWithoutSkus.length > 0) {
      /*
        Todas as imagens sem skus são exibidas sempre
      */

      $imagesWithoutSkus.removeClass('inactive').addClass('active');

      $thumbsWithoutSkus.removeClass('inactive').addClass('active');
    } else {
      /*
        Percorre todas as variantes
      */
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].main) {
          //console.info(variants[i]);

          // Procura a imagem que contém o sku e a exibe
          _this.$sliderProduct
            .find('[data-image][data-skus-image*="' + variants[i].sku + '"]')
            .addClass('active')
            .removeClass('inactive');

          _this.$thumbsProduct
            .find('[data-image-thumb][data-skus-image*="' + variants[i].sku + '"]')
            .addClass('active')
            .removeClass('inactive');
        }
      }
    }
  },
  setGallery: function () {
    var _this = this;
    var qtdImages = _this.$sliderProduct.find('[data-image]').length;

    if (qtdImages <= 1) {
      _this.$wrapperImages.addClass('without-thumbs');
    } else {
      _this.$wrapperImages.removeClass('without-thumbs');
    }

    var gallery = new Swiper('.swiper[data-main-slider]', {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      simulateTouch: false,
      navigation: {
        nextEl: '.swiper[data-main-slider] .swiper-button-next',
        prevEl: '.swiper[data-main-slider] .swiper-button-prev',
      },
    });

    /* var galleryThumbs = new Swiper('.swiper[data-slider-thumbs]', {
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      simulateTouch: true,
      watchOverflow: true,
      breakpoints: {
        280: {
          slidesPerView: 3.25,
          spaceBetween: 10,
          direction: 'horizontal'
        },
        768: {
          spaceBetween: 18,
          slidesPerView: 4.425,
          direction: 'vertical'
        }
      }
    }); */

    $(document).on('click', '[data-image-thumb]:visible', function (event) {
      event.preventDefault();

      gallery.slideTo($(this).index('[data-image-thumb]:visible'));
    });

    window.sliderProduct.push(gallery);
  },

  setButtonPoem: function () {
    const buttonPoem = document.querySelector('[data-action="go-to-poem"]');
    const sectionPoem = document.querySelector('[data-section-poem]');
    const headerHeight = document.querySelector('#header').offsetHeight;

    if (!buttonPoem || !sectionPoem) return;

    const scrollTop = +sectionPoem.offsetTop - (+headerHeight + 20);

    buttonPoem.addEventListener('click', () => {
      window.scroll({
        top: scrollTop,
        left: 0,
        behavior: 'smooth',
      });
    });
  },

  setGiftPackage: function () {
    const $openPopup = $('[data-action="open-popup"]');
    const $closePopup = $('[data-action="close-popup"]');
    const $overlay = $('[data-gift-package-overlay]');
    const $closeBtn = $('.close-popup');

    $openPopup.on('click', function () {
      $overlay.addClass('active');
      $closeBtn.attr('tabindex', 0);
    });

    $closePopup.on('click', function () {
      $overlay.removeClass('active');
      $closeBtn.attr('tabindex', -1);
    });
  },

  setToggleAttributes: function () {
    const $toggleAttributes = $('[data-toggle-attributes]');

    $toggleAttributes.each(function (idx) {
      $(this).on('click', function () {
        $(this).siblings('[data-inner]').slideToggle('fast');
      });
    });
  },

  setTabs: function () {
    const sectionTabs = document.querySelector('[data-section-tabs]');

    if (!sectionTabs) return;

    const tabs = sectionTabs.querySelectorAll('[data-tab]');
    const tabsContent = sectionTabs.querySelectorAll('[data-tab-content]');

    if (tabs.length < 0) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();

        const { id } = e.target;
        const currentTab = sectionTabs.querySelector(`[data-tab-content="${id}"]`);

        tabs.forEach((tab) => tab.classList.remove('active'));
        tabsContent.forEach((tabContent) => tabContent.classList.remove('active'));

        tab.classList.add('active');
        currentTab.classList.add('active');
      });
    });
  },

  setDetails: function () {
    const detailsSection = document.querySelector('[data-details]');

    if (!detailsSection) return;

    const carousel = detailsSection.querySelector('.swiper');
    const next = detailsSection.querySelector('.button-next');
    const prev = detailsSection.querySelector('.button-prev');

    if (window.innerWidth < 768) {
      const height = `${detailsSection.querySelector('.lazyload-container').offsetHeight + 25}px`;

      prev.style.top = height;
      next.style.top = height;
    }

    const newDetails = new Swiper(carousel, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      speed: 600,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    });
  },

  setQuotes: function () {
    const quotesSection = document.querySelector('[data-quotes]');

    if (!quotesSection) return;

    const carousel = quotesSection.querySelector('.swiper');
    //const pagination = quotesSection.querySelector('.swiper-pagination');
    const next = quotesSection.querySelector('.button-next');
    const prev = quotesSection.querySelector('.button-prev');

    const newQuotes = new Swiper(carousel, {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      /* pagination: {
        el: pagination,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      }, */
    });
  },

  setSwipersRelated: function () {
    try {
      //Quando a página carrega seleciona o primeiro swiper da lista
      loadProductSwiper(1);

      //Adiciona evento Click nos links
      $('.swiper-master .links a').on('click', function (e) {
        e.preventDefault();
        $('.swiper-master .links a').removeClass('active');
        $(this).addClass('active');
        var tag = $(this).attr('href');
        $('.swiper-home-produtos').removeClass('active');
        $('[data-link="' + tag + '"]').addClass('active');
        var val = $(this).attr('value');

        //Instancia o swiper de acordo com o index selecionado
        loadProductSwiper(val);
      });

      //Instancia dinamicamente o swiper selecionado
      function loadProductSwiper(index) {
        var swiperHomeProdutos = new Swiper(`.swiper-home-produtos-${index}`, {
          direction: 'horizontal',
          slidesPerView: 1,
          spaceBetween: 18,
          watchOverflow: true,
          breakpoints: {
            280: {
              slidesPerView: 2.5,
              spaceBetween: 10,
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 18,
            },
          },
        });
      }
    } catch (error) {
      //console.log(`${error}`);
    }
  },
  setImageCustomization: function () {
    const customization = document.querySelectorAll('[data-show-image]');

    if (customization.length > 0)
      customization.forEach((custom) => {
        custom.addEventListener('mouseover', () => {
          custom.classList.add('show');
        });
        custom.addEventListener('mouseout', () => {
          custom.classList.remove('show');
        });
      });
  },
  handleActiveCustomization: function () {
    const inputs = document.querySelectorAll('[data-customization]');

    if (inputs.length > 0) {
      inputs.forEach((input) => {
        // Verificar se o input já está desabilitado ou não
        if (input.disabled) {
          input.setAttribute('disabled', true);
        }

        // Adicionar um evento de clique para remover o 'disabled' quando clicado
        input.addEventListener('click', () => {
          input.removeAttribute('disabled');
        });
      });
    }
  },
  init: function () {
    var _this = this;

    _this.showFirstImages();
    _this.setGallery();
    _this.setToggleAttributes();
    _this.setTabs();
    _this.setDetails();
    _this.setQuotes();
    _this.setSwipersRelated();
    _this.setGiftPackage();
    _this.setImageCustomization();
    _this.handleActiveCustomization();

    window.addEventListener('load', () => {
      _this.setButtonPoem();
    });

    Variants.init();
    FormNotify.init();

    Shipping.init();
    BuyWithGift.init();

    window.mzOptions = {
      expand: 'off',
      zoomOn: 'click',
      zoomPosition: 'inner',
      expandZoomMode: 'off',
      textHoverZoomHint: '',
      textClickZoomHint: 'Clique para dar zoom',
    };
    window.mzMobileOptions = {
      zoomWidth: 30,
      zoomOn: 'click',
      zoomPosition: 'inner',
      expand: 'off',
      expandZoomMode: 'off',
      textClickZoomHint: 'Dois toques para o zoom',
    };

    var allowBuy = true;

    $(document).on('submit', '[data-form-product]', function (event) {
      event.preventDefault();
      // const checkboxLetters = document.querySelectorAll('.required-personalization');
      // if (checkboxLetters) {
      //   checkboxLetters.forEach((element) => {
      //     // Seleciona o checkbox que está marcado dentro do elemento atual
      //     const checkbox = element.querySelector('input[type="checkbox"]:checked');
      //     // Verifica se o checkbox marcado foi encontrado
      //     if (!checkbox) {
      //       allowBuy = false;
      //       return;
      //     } else {
      //       allowBuy = true;
      //     }
      //   });
      // }

      // if (!allowBuy) {
      //   let errorMessage = document.querySelector('.customizations-alert');
      //   errorMessage.classList.add('active');

      //   setTimeout(() => {
      //     errorMessage.classList.remove('active');
      //   }, 3000);

      //   return;
      // }

      var $form = $(this);
      var $parent = $form.closest('[data-box-produto]');

      var $btnComprar = $parent.find('[data-action="add-cart"]');

      var respValidated = Store.validateFormProduct($form);
      var $boxResponse = $parent.find('.resp-validate');

      if (respValidated.validated) {
        Store.addItem($form, $parent);
      } else {
        console.info('não foi');
        Store.setRespValidateProduct(respValidated, $form, $boxResponse);
      }
    });

    $('#sacola-para-presente').on('change', function () {
      $('[data-bag]').hasClass('selected')
        ? $('[data-bag]').removeClass('selected')
        : $('[data-bag]').addClass('selected');
    });
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Product.init();
});
